import React from 'react'
import JustRow from "../../../styleHelper/JustRow"
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';
import GrohNamhadod from "../../../images/designed/GrohNamhadod.svg"
import karbarHamzaman from "../../../images/designed/karbarHamzaman.svg"
import eshterahVideo from "../../../images/designed/eshterahVideo.svg"
import classOnline from "../../../images/designed/classOnline-inDsplay.svg"
import Fade from 'react-reveal/Fade';

export default function FetureRow(props) {
    return (
        <JustRow title="بدیهی است از امکانات زیر بهرمند خواهید شد" className="fetureRow">
            <Col xs={12} sm={6} md={3}>
                <Fade bottom distance="50px">
                    <Card className="text-center noStyle">
                        <Card.Img variant="top" src={GrohNamhadod} />
                        <Card.Body>
                            <Card.Title>کلاس نامحدود</Card.Title>
                            <Card.Text className="description">
                                به تعداد نامحدود در فضای کاری خود کلاس های مجزا بسازید و مخاطبان خود را در آنها اضافه کنید.
                            </Card.Text>
                        </Card.Body>
                    </Card>
                </Fade>
            </Col>
            <Col xs={12} sm={6} md={3}>
                <Fade top distance="50px">
                    <Card className="text-center noStyle">
                        <Card.Img variant="top" src={eshterahVideo} />
                        <Card.Body>
                            <Card.Title>اشتراک همزمان ویدئو</Card.Title>
                            <Card.Text className="description">
                                به طور همزمان می توانید پخش زنده 3 ویدئو را در هر کلاس داشته باشید.
                            </Card.Text>
                        </Card.Body>
                    </Card>
                </Fade>
            </Col>
            <Col xs={12} sm={6} md={3}>
                <Fade bottom distance="50px">
                    <Card className="text-center noStyle">
                        <Card.Img variant="top" src={karbarHamzaman} />
                        <Card.Body>
                            <Card.Title>کاربران همزمان</Card.Title>
                            <Card.Text className="description">
                                به طور همزمان می توانید تعداد 200 کاربر را در کلیه کلاس ها داشته باشید.
                            </Card.Text>
                        </Card.Body>
                    </Card>
                </Fade>
            </Col>
            <Col xs={12} sm={6} md={3}>
                <Fade top distance="50px">
                    <Card className="text-center noStyle">
                        <Card.Img variant="top" src={classOnline} />
                        <Card.Body>
                            <Card.Title>کلاس آنلاین</Card.Title>
                            <Card.Text className="description">
                                کلیه امکانات کلاس آنلاین همانند وایت برد، اشتراک دسکتاپ، نمایش و اشتراک انواع فایل، حضور و غیاب در اختیار شما است.
                            </Card.Text>
                        </Card.Body>
                    </Card>
                </Fade>
            </Col>
        </JustRow>
    )
}